import appConfig from 'config/app/app-config';

export default {
  log(...logArgs) {
    let CI;
    try {
      ({ CI } = process.env);
    } catch {
      //
    }

    if (CI === 'true') {
      return;
    }

    if (appConfig.log.level === 'ALL' || appConfig.log.level === 'INFO') {
      // eslint-disable-next-line no-console
      console.log(...logArgs);
    }
  },
  error(err) {
    console.error(err);
  }
};
